<div mat-dialog-title>
    <mat-icon>warning</mat-icon>
    <h1>{{ data.message | translate }}</h1>
</div>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">{{ closeButtonLabel | translate }}</button>
</mat-dialog-actions>
